import * as React from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { AlertSpg, OptionTableCell, SecurityGuard, SecurityRole, TableButton } from "@duosoftbg/nacid-components";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { Fragment } from "react";
import { useFormContext } from "react-hook-form";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import { openModal } from "../../../../store/redux/slice/ComponentsControl/referenceDataControl";
import PortalSearchTable from "../../common/table/PortalSearchTable";

const headCells = [
  {
    id: "number",
    label: "l.table.head.number",
    sortable: false,
  },
  {
    id: "domain",
    label: "l.table.head.domain",
  },
  {
    id: "id",
    label: "l.table.head.code",
  },
  {
    id: "name",
    label: "l.table.head.name",
  },
  {
    id: "index",
    label: "l.table.head.index",
  },
  {
    id: "isActive",
    label: "l.table.head.active",
  },
  {
    id: "options",
    label: "",
    sortable: false,
  },
];

const ReferenceDataListTable = ({ total, records, blockTable, onPageOrOrderChange, group }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { getValues } = useFormContext();

  const handleOpenModal = (id, domain, modalType) => {
    const payload = { id, domain, modalType };
    dispatch(openModal(payload));
  };

  return (
    <Fragment>
      {total > 0 && (
        <PortalSearchTable
          group={group}
          headCells={headCells}
          total={total}
          blockTable={blockTable}
          onPageOrOrderChange={onPageOrOrderChange}
        >
          <TableBody>
            {records.map((row, index) => (
              <TableRow hover key={row.id + "-" + row.domain}>
                <TableCell>{index + 1 + getValues().page * getValues().pageSize}</TableCell>
                <TableCell>{row.domainName}</TableCell>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.index}</TableCell>
                <TableCell>{row.isActive ? t("l.yes") : t("l.no")}</TableCell>
                <OptionTableCell>
                  <SecurityGuard checkForRoles={[SecurityRole.AcJoinedNomenclaturesEdit]}>
                    <TableButton type={"edit"} onClick={() => handleOpenModal(row.id, row.domain, "edit")} />
                    <TableButton type={"remove"} onClick={() => handleOpenModal(row.id, row.domain, "delete")} />
                  </SecurityGuard>
                </OptionTableCell>
              </TableRow>
            ))}
          </TableBody>
        </PortalSearchTable>
      )}
      {!(total > 0) && (
        <AlertSpg mt={10} mb={10} severity="info">
          {t("m.empty.list")}
        </AlertSpg>
      )}
      <SecurityGuard checkForRoles={[SecurityRole.AcJoinedNomenclaturesEdit]}>
        <Button
          startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faAdd} />}
          size={"medium"}
          type={"button"}
          variant="contained"
          color="secondary"
          onClick={() => handleOpenModal("", "", "edit")}
        >
          {t("l.btn.create")}
        </Button>
      </SecurityGuard>
    </Fragment>
  );
};

export default ReferenceDataListTable;
